import { customerChoices } from '../../../http/api/UserApi';
import { useEffect, useState } from 'react';

const useCustomerItems = () => {
  const [customerList, setCustomerList] = useState([]);
  useEffect(() => {
    fetchCustomerChoices();
  }, []);

  const fetchCustomerChoices = async () => {
    const customer = await customerChoices();
    setCustomerList(customer.customerChoicesInfo);
  };

  return customerList;
};

export default useCustomerItems;
